import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => ({
  root: {
    display: 'flex',
    borderRadius: rem(16),
    padding: rem(16),
    gap: rem(16),
    [theme.fn.smallerThan('sm')]: { flexDirection: 'column' },
    [theme.fn.largerThan('sm')]: {
      padding: rem(24),
    },
  },
  heading: {},
}))
